import {
	MapStateContext,
	type MapStateContextType,
} from 'maps/contexts/MapProvider'
import { useContext } from 'react'

/** @throws {Error} If useMapState is used without MapProvider */
export function useMapState(): MapStateContextType {
	const context = useContext(MapStateContext)

	if (context === undefined) {
		throw new Error('useMapState must be used within a MapStoresProvider')
	}

	return context
}
